/**
 * Message shown when AI speech recognition cannot process the recording.
 * Displayed when Kaldi cannot provide a score due to unclear audio or insufficient speech.
 */
export const NO_SPEECH_RECOGNITION_MESSAGE =
  "It looks like your recording wasn’t clear enough or of sufficient length for analysis. Don’t worry—try again in a quiet place and keep your microphone close for the best results.";
